import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { runISINConversionTests } from "./lib/isinApi.test";

// Production error logging
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Log startup
console.log('🚀 App starting...', {
  location: window.location.href,
  userAgent: navigator.userAgent,
  timestamp: new Date().toISOString()
});

// Make test function available in browser console for verification
if (typeof window !== 'undefined') {
  (window as any).testISINConversion = runISINConversionTests;
  console.log('🧪 ISIN Conversion Test available! Run: testISINConversion()');
}

try {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error('Root element not found');
  }
  console.log('✅ Root element found, rendering app...');
  createRoot(rootElement).render(<App />);
  console.log('✅ App rendered successfully');
} catch (error) {
  console.error('❌ Failed to render app:', error);
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: system-ui; background: #fff; color: #000;">
      <h1 style="color: #d00;">App Failed to Load</h1>
      <pre style="background: #f5f5f5; padding: 10px; overflow-x: auto;">${error instanceof Error ? error.message : String(error)}</pre>
      <p>Please check the console for more details.</p>
      <a href="/diagnostic.html" style="color: #0066cc;">Run Diagnostic Test</a>
    </div>
  `;
}
